<template>
  <div class="recordsJustif">
    <page v-if="person">
      <h4>{{ $t('records.justif.fileFrom') }} {{ person.first_name + ' ' + person.last_name.toUpperCase() }}</h4>
      <p>{{ $t('records.justif.subtitle') }}</p>
      <el-alert
        :title="$t('records.justif.alertTitle')"
        type="info"
        :description="$t('records.justif.alertDescription')"
        show-icon
      >
      </el-alert>
      <records-justif-form :person="person">
        <h4>{{ $t('records.justif.formTitle')}}</h4>
      </records-justif-form>
    </page>
  </div>
</template>

<script>
import RecordsJustifForm from '@/components/records/forms/RecordsJustifForm'
import { mapState } from 'vuex'

export default {
  name: "RecordsJustif",
  components: {
    RecordsJustifForm
  },
  computed: {
    ...mapState({
      currentRecordTenants: state => state.recordsPeople.currentRecordTenants,
      currentRecordGuarantors: state => state.recordsPeople.currentRecordGuarantors
    }),
    person() {
      if (this.$route && this.$route.params && this.$route.params.person_id) {
        return [
          ...this.currentRecordTenants,
          ...this.currentRecordGuarantors
        ].filter(item => item.id === parseInt(this.$route.params.person_id))[0]
      }

      return null
    }
  },
  mounted() {
    if (this.currentRecordTenants.length === 0 && this.currentRecordGuarantors.length === 0) {
      this.$router.push({
        name: 'records-tenant'
      })
    } else if (!this.$route.params.person_id) {
      this.$router.push({
        name: 'records-justif',
        params: {
          person_id: this.currentRecordTenants.length > 0 ? this.currentRecordTenants[0].id : this.currentRecordGuarantors[0].id
        }
      })
    }
  }
}
</script>
